// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__Wolkc","description":"styles_description__lI5p5","skeleton-animation":"styles_skeleton-animation__3D2ZG"};